import { createContext, useContext } from "react";

type SmartFormContextType = {
  methods: any;
  errors: any;
}

export const SmartFormContext = createContext<SmartFormContextType>({} as SmartFormContextType);

export const useSmartForm = () => {
  return useContext(SmartFormContext);
}

export default SmartFormContext;